// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html,\nbody {\n  font-size: 14px;\n}\n\nli:focus,\nli:active,\nbutton:focus,\nbutton:active {\n  outline: 0 !important;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type='number'] {\n  -moz-appearance: textfield;\n}\n\nsvg {\n  display: inline-block;\n}\n", ""]);
// Exports
module.exports = exports;
